<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <button
          v-if="userEditRight"                  
          type="button"
          class="btn btn-info"
          @click="addPackage()"
        >
          Create New Package
        </button>
      </div>
    </div>
    <div class="row row-spacing mb-3">
      <div class="col-md-12">
        <div
          class="table-responsive table-bordered"
          v-if="powerPackages.length > 0"
        >
          <table class="table">
            <thead>
              <tr class="text-nowrap">
                <th>Description</th>
                <th>Cost per kWh (excl. VAT)</th>
                <th>Price per kWh (excl. VAT)</th>
                <th>Price per kWh (incl. VAT)</th>
                <th>Expired</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr
                :class="{ 'bg-primary': powerPackage.expired }"
                v-for="powerPackage in powerPackages"
                :key="powerPackage.cabinetPowerBillingPackageNumber"
              >
                <td>{{ powerPackage.label }}</td>
                <td class="text-nowrap">
                  {{ getCost(powerPackage.cabinetpowerbillingpackageprices, period) }}
                </td>
                <td class="text-nowrap">
                  {{ getPrice(powerPackage.cabinetpowerbillingpackageprices, period) }}
                  <span
                    v-if="userEditRight"                  
                    style="cursor: pointer"
                    @click="openPriceModal(powerPackage)"
                    v-tooltip="'Edit Row Price'"
                    class="pull-right"
                  >
                    <em class="fa fa-edit fa-fw text-green"></em>
                  </span>
                </td>
                <td class="text-nowrap">
                  {{
                    getPrice(powerPackage.cabinetpowerbillingpackageprices, period, true)
                  }}
                </td>
                <td class="text-center">
                  <span
                    class="badge"
                    :class="
                      powerPackage.expired ? 'badge-warning' : 'badge-green'
                    "
                    >{{ powerPackage.expired }}
                  </span>
                </td>
                <td class="text-center">
                  <button
                    v-if="userEditRight"                  
                    v-tooltip="'Edit Package'"
                    @click="editPackage(powerPackage)"
                    type="button"
                    class="btn btn-sm btn-info m-1"
                  >
                    <em class="fa fa-edit fa-fw"></em>
                  </button>
                  <button
                    v-if="userEditRight"                  
                    v-tooltip="'Delete Package'"
                    type="button"
                    @click="deletePackage(powerPackage)"
                    class="btn btn-sm btn-primary"
                  >
                    <em class="fa fa-trash fa-fw"></em>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="alert alert-info">No Cabinet Power Packages Available</div>
      </div>
    </div>
    <ModifyPowerPackageModal
      ref="modifyPackageModal"
      :pricePackage="newPackage"
      @packageAdded="packageAdded"
      @packageEdited="loadPowerPackages()"
    />
    <CabinetPowerPriceModal
      ref="addPriceModal"
      :row-price="rowPrice"
      :new-price="newPrice"
      @addPrice="addPrice"
      @pricesAdded="loadPowerPackages()"
    />
  </div>
</template>

<script>
import PriceFunctions from "@/components/Admin/PriceFunctions";
import ModifyPowerPackageModal from "@/components/Admin/Modals/ModifyPowerPackageModal";
import CabinetPowerPriceModal from "@/components/Admin/Modals/CabinetPowerPriceModal";

export default {
  extends: PriceFunctions,
  components: {
    ModifyPowerPackageModal,
    CabinetPowerPriceModal
  },
  props: {
    productNumber: {
      type: Number,
      required: true,
    },
    userEditRight: {
      type: Boolean,
      required: true
    },

  },
  data() {
    return {
      powerPackages: [],
      period: this.getCurrentPeriod(),
      rowPrice: [],
      pricePackage: {},
      newPackage: {
        cabinetpowerbillingpackages: {}
      },
      newPrice: {},
    };
  },
  mounted() {
    this.loadPowerPackages();
  },
  methods: {
    loadPowerPackages() {
      this.$http
        .get(
          this.$config.aimsAPI +
            "pricing/powerpackages/product/" +
            this.productNumber
        )
        .then(
          (response) => {
            this.pricePackage = response.data;
            this.powerPackages = response.data.cabinetpowerbillingpackages;
            this.setNewPrice();
          },
          (error) => {
            console.error(error);
            this.showError("Error Fetching Cabinet Power Packages", error);
          }
        );
    },
    setNewPrice() {
      this.newPrice = this.deepCopyObject(this.pricePackage.cabinetpowerbillingpackageprice);
    },
    openPriceModal(powerPackage) {
      this.rowPrice = this.deepCopyObject(
        powerPackage.cabinetpowerbillingpackageprices || []
      );
      this.newPrice.cabinetPowerBillingPackageNumber = powerPackage.cabinetPowerBillingPackageNumber;
      this.$refs.addPriceModal.open();
    },
    addPrice(newPrice) {
      this.rowPrice.forEach((price) => {
        if (price.validUntil == 0) {
          price.validUntil = this.decreaseBillingPeriod(newPrice.validFrom);
        }
      });
      this.rowPrice.push(newPrice);
      this.setNewPrice();
      this.newPrice.cabinetPowerBillingPackageNumber = newPrice.cabinetPowerBillingPackageNumber;
    },
    addPackage() {
      this.newPackage = this.pricePackage;
      this.$refs.modifyPackageModal.open();
    },
    editPackage(powerPackage) {
      this.newPackage = this.deepCopyObject(powerPackage);
      this.$refs.modifyPackageModal.open();
    },
    packageAdded(powerPackage) {
      powerPackage.cabinetpowerbillingpackageprices = [];
      this.powerPackages.push(powerPackage);
      this.openPriceModal(powerPackage);
    },
    deletePackage(powerPackage) {
      this.$swal({
        title: "Are you sure you want to delete this Package?",
        type: "warning",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.$http
            .delete(
              this.$config.aimsAPI +
                "pricing/pricepackages/" +
                powerPackage.objKey +
                "?objClassName=" +
                powerPackage.class
            )
            .then(
              (response) => {
                this.showSuccess(response.data.message);
                this.loadPowerPackages();
              },
              (error) => {
                this.showError("Error Deleting Price Package", error);
              }
            );
        }
      });
    },
    getCost(data, period) {
      if (data) {
        if (data.length > 0) {
          let price = data.filter((price) => period >= price.validFrom);
          price.forEach((newPrice) => {
            if (newPrice.validUntil != 0) {
              price = price.filter((price) => period <= price.validUntil);
            } else {
              price = newPrice;
            }
          });
          if (Array.isArray(price)) {
            if (price.length > 0) {
              return this.currencyFormat(
                parseFloat(price[0].costPerKwh)
              );
            } else {
              return "R " + 0;
            }
          } else {
            return this.currencyFormat(
              parseFloat(price.costPerKwh)
            );
          }
        } else {
          return "R " + 0;
        }
      } else {
        return 0;
      }
    },
  },
};
</script>
